import { VeltComments, VeltCommentTool } from '@veltdev/react';
import { useEffect } from 'react';
import './CommentsInbox.css';

function CommentsInbox() {

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    return (
        <>
            <VeltComments inboxMode={true} />
            <div className="comment-tool-container">
                <p className='boujeeText'>Click on the comment pin to view the comment inbox!</p>
                <VeltCommentTool />
            </div>
        </>
    )
}

export default CommentsInbox;